import React from 'react';
import styled from '@emotion/styled';

import { ProductComponentProps } from '../../types/types';

import { DocumentsHeader } from './DocumentsHeader';
import { DocumentsFilesList } from './DocumentsFilesList';

import { productComponentContainerPaddingStyle, productComponentContainerBottomPaddingStyle } from '../shared/styles';

const DocumentsContainer = styled.div(productComponentContainerPaddingStyle, productComponentContainerBottomPaddingStyle, {
  // z-index is 1 here because this component doesn't allow the header pattern to overlap
  backgroundColor: 'var(--color-white)',
  position: 'relative',
  zIndex: 1,
});

// Descoped
export const Documents: React.FC<ProductComponentProps> = props => {
  const { title, description, files } = props.productComponent;
  const componentIdx = props.index ?? 0;
  return (
    <DocumentsContainer id={`mp-product-documents-${componentIdx}`} data-testid='mp-product-documents'>
      <DocumentsHeader title={title} strapline={description} />
      <DocumentsFilesList files={files} />
    </DocumentsContainer>
  );
};
